import { FundingSource } from "@faire/retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/FundingSource";
import { INestedCheckboxOption } from "@faire/retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/NestedCheckboxes/NestedCheckboxes";
import { useRef } from "react";

export const useNestedCheckboxes = (
  options: Array<INestedCheckboxOption>,
  initialCheckedBoxes: Set<string>
) => {
  const checkedFieldsRaw: Record<FundingSource, boolean> = Object.values(
    FundingSource
  ).reduce<Record<FundingSource, boolean>>(
    (acc, key) => ({ ...acc, [key]: false }),
    {} as Record<FundingSource, boolean>
  );
  options.forEach((option) =>
    checkIfBoxChecked(option, initialCheckedBoxes, checkedFieldsRaw)
  );
  const checkedFields =
    useRef<Record<FundingSource, boolean>>(checkedFieldsRaw);

  const toggle = (key: FundingSource) => {
    checkedFields.current[key] = !checkedFields.current[key];
  };

  const getCheckedKeys = (
    checkboxOptions: INestedCheckboxOption[]
  ): string[] => {
    const checkedKeys: string[] = [];

    checkboxOptions.forEach(({ key, children }) => {
      if (!checkedFields.current[key]) {
        return;
      }
      if (children) {
        checkedKeys.push(...getCheckedKeys(children));
      } else {
        checkedKeys.push(key);
      }
    });

    return checkedKeys;
  };

  return { checkedFields, toggle, getCheckedKeys };
};

const checkIfBoxChecked = (
  option: INestedCheckboxOption,
  initialCheckedBoxes: Set<string> | undefined,
  checkedFieldsRaw: Record<FundingSource, boolean>
): boolean => {
  let isChecked = false;
  if (option.children) {
    isChecked = option.children
      .map((child) =>
        checkIfBoxChecked(child, initialCheckedBoxes, checkedFieldsRaw)
      )
      .some((isChildChecked) => isChildChecked);
  } else {
    isChecked = !!initialCheckedBoxes?.has(option.key);
  }
  checkedFieldsRaw[option.key] = isChecked;

  return isChecked;
};
